import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../service/api.service';
import { NotificationService } from '../service/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-apoadminpanel',
  templateUrl: './apoadminpanel.component.html',
  styleUrls: ['./apoadminpanel.component.css']
})
export class ApoadminpanelComponent implements OnInit {
 selectedTab = 'timeline';
   yearRange: string = '';
schemeList: any[]=[];
subSchemeList: any[]=[];
componentList: any[]=[];
divisionList: any[]=[];
timelines: any[]=[];
selectedMajorScheme: any="";
selectedScheme: any="";
selectedComponent: any="";
selectedComponentName: string = '';
userid: any;
divisionSearch:any="";
isEditMode = false;

/* --- modal helpers --- */
confirmMessage: string = '';
pendingRow: any = null;
pendingAction: 'single' | 'all' = 'single';

    // Modal related
  divisionFilter = '';
  selectedDivisionIds: number[] = [];
  bulkStartDate: string = '';
  bulkEndDate: string = '';

  constructor(  private readonly apiService: ApiService,
      private readonly fb: FormBuilder,
      private readonly notifyService:NotificationService,
      private readonly router:Router)
       {
          const userdata=sessionStorage.getItem('user');
          if(userdata!=null){
            const user=JSON.parse(userdata);
            this.userid=user.userid;
            if(user.roleId!==1 && user.roleId!==13){
              this.router.navigate(['not-found']);
            }
          }else{
            this.router.navigate(['/']);
          }
       }

  ngOnInit(): void {
      const currentYear = new Date().getFullYear();
    this.yearRange = `${currentYear}-${currentYear + 1}`;
        this.getAllSchemeDD();
  }
 selectTab(tab: string) {
    this.selectedTab = tab;
  }
  getAllSchemeDD() {
    this.apiService.request('GET', 'api/v1/APO/getAllSchemeDD').subscribe((data: any) => {
    if (data) {
      this.schemeList = data;
      }
    });
  }
   onMajorSchemeChange() {
   this.apiService.request('GET', `api/v1/APO/getAllSubSchemeDD?schemeId=${Number(this.selectedMajorScheme)}`).subscribe(
     (data: any) => {
       if (data && Array.isArray(data)) {
         this.subSchemeList = data;  
       } 
     },
     (error) => {  
       this.notifyService.showError('Failed to load scheme', 'Error');
     });
    this.selectedScheme = "";
    this.componentList = [];
  }

  onSchemeChange() {
  
  this.apiService.request('GET', `api/v1/APO/getAllComponentDDByScheme?schemeId=${this.selectedScheme}`).subscribe(
    (data: any) => {
    
      if (data && Array.isArray(data)) {
        this.componentList = data;
      } 
    },
    (error) => {
    
    }
  );
    this.selectedComponent = "";
  }

  loadTimelines() {
      const compId = Number(this.selectedComponent);
      const fyId = 1; // Replace with actual selected FY if needed

      if (!compId) {
        this.notifyService.showInfo('Please select a component.', 'Validation');
        return;
      }
     
       // Step 1: Fetch division list
  this.apiService.request('GET', 'api/v1/masters/getAllDivision').subscribe((divData: any) => {
    if (Array.isArray(divData)) {
      this.divisionList = divData;

      // Step 2: Fetch timeline data with params
      this.apiService.request(
        'GET',
        `api/v1/apo-timeline/list?fyId=${fyId}&componentId=${compId}`
      ).subscribe((timelineData: any[]) => {
        
        const today = new Date();


        const timelineMap = new Map<number, any>(
          timelineData.map(t => [t.divisionId, t])
        );

        // Step 3: Merge both datasets
        this.timelines = this.divisionList.map((d: any) => {
          const existing = timelineMap.get(d.divisionId);
          const start = existing?.startDate ? new Date(existing.startDate) : null;
          const end = existing?.endDate ? new Date(existing.endDate) : null;

          let timelineStatus = '';
          if (start && end) {
            if (today < start) timelineStatus = 'Not Started';
            else if (today > end) timelineStatus = 'Exceeded';
            else timelineStatus = 'Active';
          } else {
            timelineStatus = 'Not Set';
          }

          return {
            id: 0,
            divisionId: d.divisionId,
            divisionName: d.divisionName,
            fyId,
            componentId: compId,
            startDate: existing?.startDate || '',
            endDate: existing?.endDate || '',
            isActive: true,
            createdBy: this.userid,
            updatedBy: this.userid,
            isEditMode: false,
            timelineStatus  // ✅ status field
          };
        });
      }, () => {
        this.notifyService.showError('Failed to fetch timeline data.', 'Error');
      });

    } else {
      this.notifyService.showError('Failed to fetch division list.', 'Error');
    }
  });



  
  //    this.timelines = [
  //   { divisionId: 1, divisionName: 'Angul', startDate: '', endDate: '', isEditMode: false },
  //   { divisionId: 2, divisionName: 'Cuttack', startDate: '', endDate: '', isEditMode: false },
  //   { divisionId: 3, divisionName: 'Sambalpur', startDate: '', endDate: '', isEditMode: false }
  // ];
//   this.timelines = data.map((row: any) => ({
//   ...row,
//   isEditMode: false
// }));

//  const compId = Number(this.selectedComponent);
//   if (!compId) return;

//   this.apiService.request('GET', 'api/v1/masters/getAllDivision').subscribe((data: any) => {
//     if (data && Array.isArray(data)) {
//       this.divisionList = data;
//       this.timelines = this.divisionList.map((d: any) => ({
//         id: 0,
//         divisionId: d.divisionId,
//         divisionName: d.divisionName,
//         fyId: 1,  // update if needed
//         componentId: compId,
//         startDate: '',
//         endDate: '',
//         isActive: true,
//         createdBy: this.userid,
//         updatedBy: this.userid,
//         isEditMode: false
//       }));
//     }
//   });
  }
   saveTimeline(row: any) {
    // Call API here or handle logic
     const payload = [{
          id: row.id || 0,
          divisionId: row.divisionId,
          divName: row.divisionName,
          fyId: 1, // or your selected fyId
          componentId: Number(this.selectedComponent),
          startDate: row.startDate,
          endDate: row.endDate,
          isActive: true,
          createdBy: this.userid,
          updatedBy: this.userid
        }];
    this.apiService.request('POST', 'api/v1/apo-timeline/save-all', payload)
    .subscribe(() => {
       this.updateTimelineStatus(row);
      this.notifyService.showSuccess(`Saved timeline for ${row.divisionName}`, 'Success');
      row.isEditMode = false;
    }, () => {
      this.notifyService.showError('Failed to save timeline', 'Error');
    });
  }

  clearTimeline(row: any) {
    row.startDate = '';
    row.endDate = '';
  }
  saveAllTimelines() {
    // for (let row of this.timelines) {
    //   if (row.startDate && row.endDate) {
    //     this.saveTimeline(row);
    //   }
    // }
    // this.notifyService.showSuccess('All timelines saved!', 'Success');




      // let anySaved = false;

      //   for (let row of this.timelines) {
      //     if (row.isEditMode && row.startDate && row.endDate) {
      //       this.saveTimeline(row);  // Replace with actual API save if needed
      //       row.isEditMode = false;  // Set back to readonly
      //       anySaved = true;
      //     }
      //   }

      //   if (anySaved) {
      //     this.notifyService.showSuccess('All editable timelines saved!', 'Success');
      //   } else {
      //     this.notifyService.showInfo('No changes to save.', 'Info');
      //   }

const editableRows = this.timelines.filter(t => t.isEditMode && t.startDate && t.endDate);
  if (editableRows.length === 0) {
    this.notifyService.showInfo('No editable timelines found.', 'Info');
    return;
  }

  const payload = editableRows.map(row => ({
    id: row.id || 0,
    divisionId: row.divisionId,
    divName: row.divisionName,
    fyId: 1,
    componentId: Number(this.selectedComponent),
    startDate: row.startDate,
    endDate: row.endDate,
    isActive: true,
    createdBy: this.userid,
    updatedBy: this.userid
  }));
  this.apiService.request('POST', 'api/v1/apo-timeline/save-all', payload)
    .subscribe(() => {
        this.updateAllTimelineStatuses();
      this.notifyService.showSuccess('All timelines saved successfully!', 'Success');
      this.timelines.forEach(t => t.isEditMode = false);
    }, () => {
      this.notifyService.showError('Failed to save timelines', 'Error');
    });

  }
  toggleRowEditMode(row: any) {
  if (row.isEditMode) {
    this.saveTimeline(row); // Save on toggle back to read-only
  }
  row.isEditMode = !row.isEditMode;
}
updateTimelineStatus(row: any) {
  const now = new Date();
  const start = new Date(row.startDate);
  const end = new Date(row.endDate);

  if (now < start) {
    row.timelineStatus = 'Not Started';
  } else if (now > end) {
    row.timelineStatus = 'Exceeded';
  } else {
    row.timelineStatus = 'Active';
  }
}

updateAllTimelineStatuses() {
  const now = new Date();
  this.timelines.forEach(row => {
    if (row.startDate && row.endDate) {
      const start = new Date(row.startDate);
      const end = new Date(row.endDate);

      if (now < start) {
        row.timelineStatus = 'Not Started'; // 🔵 primary
      } else if (now > end) {
        row.timelineStatus = 'Exceeded'; // 🔴 danger
      } else {
        row.timelineStatus = 'Active'; // 🟢 success
      }
    } else {
      row.timelineStatus = null;
    }
  });
}


  filteredTimelines() {
  if (!this.divisionSearch) return this.timelines;
  const keyword = this.divisionSearch.toLowerCase();
  return this.timelines.filter(t => t.divisionName.toLowerCase().includes(keyword));
}

clearSearch() {
  this.divisionSearch = '';
}
getAllDivision(){
   this.apiService.request('GET', 'api/v1/masters/getAllDivision').subscribe((data: any) => {
   if (data && Array.isArray(data)) {
        this.divisionList = data.map((d: any) => ({
        divisionId: d.divisionId,
        divisionName: d.divisionName
      }));
     //console.log(this.divisionList)
      // Initialize timelines with startDate/endDate if not already loaded
         this.timelines = this.divisionList.map(div => {
        const existing = this.timelines.find(t => t.divisionId === div.divisionId);
        return {
          divisionId: div.divisionId,
          divisionName: div.divisionName,
          startDate: existing?.startDate || '',
          endDate: existing?.endDate || ''
        };
      });
      //console.log( this.timelines);
    }

   });
}
openTimelineModal() {
  const compId = Number(this.selectedComponent); // 🔧 ensure number type
  const component = this.componentList.find(c => c.id === compId);
  this.selectedComponentName = component ? component.name : '';

  if (!compId) {
    this.notifyService.showError('Please select a valid component.', 'Validation');
    return;
  }

  this.loadTimelines();  // ✅ Load both division list and existing timeline data

  ($('#timelineModal') as any).modal('show');
}
openConfirmModal(action: 'single' | 'all', row: any = null) {
   if (action === 'single' && row) {
    if (!this.isValidDateRange(row)) {
      this.notifyService.showError('End Date must be after Start Date', 'Validation Error');
      return;
    }
  }

  if (action === 'all') {
    const invalid = this.timelines.find(t => t.isEditMode && !this.isValidDateRange(t));
    if (invalid) {
      this.notifyService.showError(`Invalid date range in "${invalid.divisionName}"`, 'Validation Error');
      return;
    }
  }

  this.pendingAction = action;
  this.pendingRow = row;

  const message =
    action === 'single'
      ? `Do you want to save timeline for "${row.divisionName}"?`
      : 'Do you want to save all edited timelines?';

  Swal.fire({
    html: message,
   //icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    width: '320px',                  // ⬅️ Compact width
    padding: '0.8em',                // ⬅️ Less padding
    background: '#fff',
    confirmButtonColor: '#198754',   // Bootstrap green
    cancelButtonColor: '#6c757d',    // Bootstrap gray
    buttonsStyling: true,
    customClass: {
      popup: 'shadow-sm rounded-2',
      title: 'fs-6',
      htmlContainer: 'fs-6',
      confirmButton: 'btn btn-sm btn-success me-2',
      cancelButton: 'btn btn-sm btn-secondary'
    }
  }).then(result => {
    if (result.isConfirmed) {
      this.proceedSave();
    }
  });
}
proceedSave() {

  if (this.pendingAction === 'single' && this.pendingRow) {
    /* same as earlier toggle-save */
    this.toggleRowEditMode(this.pendingRow);
  } else if (this.pendingAction === 'all') {
    this.saveAllTimelines();
  }
}
isValidDateRange(row: any): boolean {
  return new Date(row.endDate) > new Date(row.startDate);
}
  filteredTimelinesForCheck() {
    const keyword = this.divisionFilter.toLowerCase();
    return this.timelines.filter(t =>
      t.divisionName.toLowerCase().includes(keyword)
    );
  }

  toggleDivision(divisionId: number) {
    const index = this.selectedDivisionIds.indexOf(divisionId);
    if (index >= 0) {
      this.selectedDivisionIds.splice(index, 1);
    } else {
      this.selectedDivisionIds.push(divisionId);
    }
  }

  areAllSelected(): boolean {
    const filtered = this.filteredTimelinesForCheck().map(t => t.divisionId);
    return filtered.length > 0 && filtered.every(id => this.selectedDivisionIds.includes(id));
  }

  toggleSelectAll(event: any) {
    const filtered = this.filteredTimelinesForCheck().map(t => t.divisionId);
    if (event.target.checked) {
      this.selectedDivisionIds = Array.from(new Set([...this.selectedDivisionIds, ...filtered]));
    } else {
      this.selectedDivisionIds = this.selectedDivisionIds.filter(id => !filtered.includes(id));
    }
  }

applyBulkDates() {
  if (!this.bulkStartDate || !this.bulkEndDate) {
    this.notifyService.showError("Select both Start and End date.", "Validation");
    return;
  }

  if (new Date(this.bulkEndDate) <= new Date(this.bulkStartDate)) {
    this.notifyService.showError("End Date must be after Start Date.", "Validation");
    return;
  }

  if (this.selectedDivisionIds.length === 0) {
    this.notifyService.showError("Select at least one division.", "Validation");
    return;
  }

  

   /* ── 2️⃣  Apply dates locally ────────────────────── */
  const fyId   = 1;                            // use your actual FY selector
  const compId = Number(this.selectedComponent);

  const affectedRows = this.timelines
    .filter(t => this.selectedDivisionIds.includes(t.divisionId));

  affectedRows.forEach(t => {
    t.startDate  = this.bulkStartDate;
    t.endDate    = this.bulkEndDate;
    t.isEditMode = true;                       // mark as edited for UI
  });

  /* ── 3️⃣  Build payload for save-all API ─────────── */
  const payload = affectedRows.map(t => ({
    id:           0,                    // 0 = create, >0 = update
    divisionId:  t.divisionId,
    divName:     t.divisionName,
    fyId:        fyId,
    componentId: compId,
    startDate:   t.startDate,
    endDate:     t.endDate,
    isActive:    true,
    createdBy:   this.userid,
    updatedBy:   this.userid
  }));

  /* ── 4️⃣  Persist to backend ─────────────────────── */
  this.apiService.request('POST', 'api/v1/apo-timeline/save-all', payload)
    .subscribe(() => {
      this.notifyService.showSuccess('Bulk timeline saved!', 'Success');
      // reset edit flags
      affectedRows.forEach(r => (r.isEditMode = false));
      // close modal
      ($('#timelineModal') as any).modal('hide');
      // clear selections
      this.clearAllSelections();
    }, () => {
      this.notifyService.showError('Failed to save bulk timelines.', 'Error');
    });

  // for (let row of this.timelines) {
  //   if (this.selectedDivisionIds.includes(row.divisionId)) {
  //     row.startDate = this.bulkStartDate;
  //     row.endDate = this.bulkEndDate;
  //     row.isEditMode = true;  // ✅ Mark for saveAllTimelines()
  //   }
  // }

  // this.saveAllTimelines(); // 🔁 Reuse existing method

  // ($('#timelineModal') as any).modal('hide');
  // this.clearAllSelections();
}

  getSelectedDivisionNames(): string[] {
  return this.divisionList
    .filter(div => this.selectedDivisionIds.includes(div.divisionId))
    .map(div => div.divisionName);
}
  clearAllSelections() {
  this.selectedDivisionIds = [];
}
}

